export default __webpack_public_path__ + "static/media/dan1.3928a274.png";